<template>
  <div>
    <div class="img-top">
<!--      <div class="text-title">平台简介</div>-->
      <!--			<div class="text-subtitle">解决你的临时用电需求 专注用电需求</div>-->
    </div>

    <div style="height: 800px;background-color: #fff;width: 15.19rem;margin: 10px auto 30px auto;">
      <div class="section-top">
        <div class="section-top1">
          <span style=" font-size: 20px;font-weight: 800;">无忧用电</span>
          <span>——应急供电资源服务共享平台旨在为客户与设备资源厂商之间提供精准连接的通道，为客户提供应急保障服务。无忧用电平台目前具备应急供电、应急照明两大模块功能，搭建起客户与资源厂商之间的网络服务平台和资源厂商入驻平台，客户通过平台选择可满足自身需求的资源项目。目前已入驻平台厂商12家，统筹调度应急供电设备530余台，全力保障省会市政工程与民生用电稳定，实现资源供应商、用电客户与企业三方合作共赢。
          </span>
        </div>

      </div>
      <div class="section-bottom">

      </div>
<!--      <div style="height: 50px;"></div>-->
    </div>

    <div style="height: 30px;"></div>
  </div>
</template>

<script>


export default {
  components: {
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  },
};
</script>

<style scoped>
.img-top {
  height: 2.1rem;
  background-color: #c4c4c4;
  background-image: url("../../assets/image/banner1.jpg");
  background-size: 100% 100%;
  padding: 0.59rem 0 0 2rem;
  -webkit-box-sizing: border-box;
}

.section-top {
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 1.8;
  color: #000000;
  text-indent: 2em;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;

  .section-top1{
    height: 120px;
    width: 90%;
    background-image: url("../../assets/image/文字背景.jpg");
    background-size: 100% 100%;
    padding-top: 10px;
  }

}
.section-bottom {
  height:600px;
  background-image: url("../../assets/image/pingtaijieshao.png");
  background-size: 100% 100%;
}
</style>
